const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer className="text-center py-4 text-sm text-gray-400 border-t border-white/20 mt-10">
       © {year} Vinodh Kumar. All rights reserved.
    </footer>
  );
};

export default Footer;
